// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"023df594","113":"156ad868","140":"60f5069f","342":"28dfd74e","452":"f0d86bbc","492":"682cea3a","683":"f9688127","727":"d5180c8e","748":"8440f4dd","775":"29147173","904":"966788eb","994":"a9e0e423"}[chunkId] + ".chunk.js";
};